import React, { useState, useEffect } from 'react';
import './Modal.css';

// Helper to get today's date in YYYY-MM-DD format
const getTodayString = () => new Date().toISOString().split('T')[0];

const ProjectModal = ({ show, onClose, onSave, project }) => {
  const [name, setName] = useState('');
  const [manager, setManager] = useState('');
  const [status, setStatus] = useState('未开始');

  // New state for date handling
  const [startDate, setStartDate] = useState(getTodayString());
  const [duration, setDuration] = useState(10); // Default duration
  const [endDate, setEndDate] = useState('');
  const [isDurationMode, setIsDurationMode] = useState(true);

  // Effect to sync form with editing project or reset for a new one
  useEffect(() => {
    if (project) { // Editing existing project
      setName(project.name);
      setManager(project.manager || '');
      setStatus(project.status);
      const start = project.startDate?.split('T')[0] || getTodayString();
      const end = project.endDate?.split('T')[0] || '';
      setStartDate(start);
      setEndDate(end);
      setIsDurationMode(false); // Default to end date mode when editing
    } else { // Adding new project
      setName('');
      setManager('林毅敏');
      setStatus('未开始');
      setStartDate(getTodayString());
      setDuration(10);
      setIsDurationMode(true);
    }
  }, [project, show]);

  // Effect to calculate end date from start date and duration
  useEffect(() => {
    if (isDurationMode && startDate && duration > 0) {
      const start = new Date(startDate);
      start.setDate(start.getDate() + parseInt(duration, 10));
      setEndDate(start.toISOString().split('T')[0]);
    }
  }, [startDate, duration, isDurationMode]);

  if (!show) {
    return null;
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave({ name, manager, startDate, endDate, status });
    onClose();
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h2>{project ? '编辑项目' : '添加新项目'}</h2>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>项目名称</label>
            <input type="text" value={name} onChange={e => setName(e.target.value)} required />
          </div>
          <div className="form-group">
            <label>项目经理</label>
            <input type="text" value={manager} onChange={e => setManager(e.target.value)} required />
          </div>
          <div className="form-group">
            <label>开始日期</label>
            <input type="date" value={startDate} onChange={e => setStartDate(e.target.value)} required />
          </div>
          
          <div className="form-group">
            <label>
              <input 
                type="radio" 
                name="date-mode" 
                checked={isDurationMode} 
                onChange={() => setIsDurationMode(true)}
              /> 持续天数
            </label>
            <input 
              type="number" 
              value={duration} 
              onChange={e => setDuration(e.target.value)}
              disabled={!isDurationMode}
              min="1"
            />
          </div>

          <div className="form-group">
            <label>
              <input 
                type="radio" 
                name="date-mode" 
                checked={!isDurationMode} 
                onChange={() => setIsDurationMode(false)}
              /> 结束日期
            </label>
            <input 
              type="date" 
              value={endDate}
              onChange={e => setEndDate(e.target.value)} 
              disabled={isDurationMode}
              required={!isDurationMode}
            />
          </div>

          <div className="form-group">
            <label>状态</label>
            <select value={status} onChange={e => setStatus(e.target.value)}>
              <option value="未开始">未开始</option>
              <option value="进行中">进行中</option>
              <option value="已完成">已完成</option>
            </select>
          </div>
          <div className="modal-actions">
            <button type="submit" className="btn">保存</button>
            <button type="button" className="btn btn-secondary" onClick={onClose}>取消</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ProjectModal; 